import { Typography, Button, Box, Container } from '@mui/material';
import { HashLink } from 'react-router-hash-link';
import React, { useEffect, useState, useRef } from 'react';
import ResponsiveAppBarAlt from './ResponsiveAppBarAlt';
import Contactform from './Contactform';
import Footer from "./Footer";
import '../App.css';

const ScrollAnimation = () => {
  const [isHeroNavVisible, setIsHeroNavVisible] = useState(true);
  const heroNavWrapperRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const screenHeight = window.innerHeight;


    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
          const observer = new IntersectionObserver(
              ([entry]) => {
                  setIsHeroNavVisible(entry.isIntersecting);
                  const navbar = document.querySelector(".navbar.alt");
                  if (navbar) {
                      if (!entry.isIntersecting) {
                          navbar.style.marginTop = "0px";
                      } else {
                          navbar.style.marginTop = "-100px";
                      }
                  }
              },
              { threshold: 0.01 }
    );

    if (heroNavWrapperRef.current) {
      observer.observe(heroNavWrapperRef.current);
    }

    return () => {
      if (heroNavWrapperRef.current) {
        observer.unobserve(heroNavWrapperRef.current);
      }
    };
  }, []);


  return (

    <div className="App">
<ResponsiveAppBarAlt />

<main>

  <Box className="heroWrapper subpage" id="start">

  <img src="Beglaubigung.webp" className='herobackimg' />
    <Box className='heroWrapperLayer'></Box>
    <Container maxWidth="lg" className="containerHero" /*sx={{width: 300,backgroundColor: 'success.main',}}*/>

    </Container>

    <Box className="heroNavWrapper" ref={heroNavWrapperRef}>
      <HashLink className='navItemHero' smooth to="/#leistungen">Leistungen</HashLink>
      <HashLink className='navItemHero' smooth to="/#notare">Notare</HashLink>
      <HashLink className='navItemHero' smooth to="/team">Team</HashLink>
      <HashLink className='navItemHero' smooth to="#kontakt">Kontakt</HashLink>
      <HashLink className='navItemHero flex' smooth to="/en"><img src="en-flag.png" className='navFlagIcon' />EN</HashLink>
    </Box>

    {/* <div className="heroCTAWrapper">
      <Button href="#" target='_blank' variant='contained' className='mandantenCTATop'>Mandanten Login<img src='arrow-weiss.png' className='servOptItemArrow' /></Button>
    </div> */}
  </Box>


  <Box className="mainWrapper">

    <Container maxWidth="lg" className="subPageContainerThin">

      <HashLink className='breadcrumb' smooth to="/#leistungen">Leistungen</HashLink>
            <Typography variant='h1' className='subTitle'>Beglaubigungen</Typography>


      <Box className="intendTextWrapper">
        <Box className="textintendInnerWrapper margin">
        <Typography variant='body1' className='sectionText'>
            Verschiedene Stellen im In- und Ausland fordern die Beglaubigung eines Dokuments oder die Beglaubigung einer Unterschrift durch einen Notar. Bei der Beglaubigung einer Abschrift prüft der Notar lediglich, dass das ihm vorgelegte Dokument identisch ist mit der Abschrift, die er erteilt. Bei der Unterschriftenbeglaubigung prüft der Notar nur anhand eines amtlichen Lichtbildausweises, ob die richtige Person das Dokument unterschreibt. In beiden Fällen prüft der Notar nicht, ob das Dokument inhaltlich richtig ist und berät auch grds. nicht zu den rechtlichen Folgen des jeweiligen Rechtsgeschäfts.<br /><br />
            Falls Sie ein Dokument im Ausland verwenden wollen, benötigen Sie dafür meist eine zusätzliche besondere Beglaubigung. Die sog. Apostille erteilt der Präsident des Landgerichts Bonn. Wir können das Dokument beim Landgericht Bonn für Sie einreichen und die Erteilung der Apostille für Sie beantragen. In anderen Ländern ist dagegen die aufwendige Legalisation des Dokuments durch ein Konsulat erforderlich. Bitte stimmen Sie vorab mit den ausländischen Stellen ab, welche Art von Nachweis diese verlangen.
            </Typography>

            <Button className='btnSecondary'><HashLink smooth to="#kontakt">Beglaubigung Formular</HashLink></Button>
        </Box>
      </Box>

    </Container>



                      <Box className="map" id="map">
                          <Box className="contactMap">
                              <iframe width="100%" height="100%" frameBorder="0" allowFullScreen allow="geolocation" src="//umap.openstreetmap.de/en/map/notare-harbecke-thelen_85729?scaleControl=false&miniMap=false&scrollWheelZoom=true&zoomControl=true&editMode=disabled&moreControl=true&searchControl=false&tilelayersControl=null&embedControl=false&datalayersControl=null&onLoadPanel=none&captionBar=false&captionMenus=false&captionControl=null&locateControl=null&measureControl=null"></iframe>

                          </Box>

                      </Box>



    <Box className="section bannergrey" id="kontakt">
      <Container maxWidth="lg" className="container" id="kontakt">
        <Box className="kontaktGrid">
          <Box className="kontaktLeftSide">
            <Typography variant='h2' className='sectionTitle white'>
              Sie haben Fragen?  <br />
              Wir stehen Ihnen gerne zur Verfügung und beantworten Ihr Anliegen in Kürze.
            </Typography>
            <Typography variant='body1' paragraph className='whiteText'>
              Harbecke & Thelen Notare<br />
              Holzgasse 29 - 33<br />
              Siegburg 53721<br />
            </Typography>
          </Box>
          <Contactform />
        </Box>
      </Container>
    </Box>

  </Box>

</main >
<Footer />
    </div >
  );
};

export default ScrollAnimation;